import React, { useCallback } from 'react'
import MapLibreMap, { addGeoJsonLayer, fitBoundsToGeoJson } from './MapLibreMap'

// Color scheme matching quadra_map.js
const COLORS = {
  quadra: '#81ADD2',
  lotesPolo: '#81ADD2',
  lotes: '#555'
}

export default function QuadraMapLibre({ quadraId, className = '' }) {
  const handleMapReady = useCallback(async (map) => {
    try {
      // Fetch all data in parallel
      const [quadra, lotes, lotesPolo] = await Promise.all([
        fetch(`/quadras/${quadraId}.json`).then(r => r.json()),
        fetch(`/quadras/${quadraId}/lotes`).then(r => r.json()),
        fetch(`/quadras/${quadraId}/lotes_polo`).then(r => r.json())
      ])

      // Add quadra boundary (background layer)
      if (quadra) {
        addGeoJsonLayer(map, 'quadra', quadra, {
          type: 'both',
          color: COLORS.quadra,
          opacity: 0.1,
          lineWidth: 1
        })

        // Fit bounds to quadra
        fitBoundsToGeoJson(map, quadra)
      }

      // Add lotes outside polo
      if (lotes?.features?.length > 0) {
        addGeoJsonLayer(map, 'lotes', lotes, {
          type: 'line', // Only outline, no fill
          color: COLORS.lotes,
          lineWidth: 1,
          onClick: (e) => {
            const id = e.features[0]?.properties?.id
            if (id) window.location.href = `/lotes/${id}`
          }
        })
      }

      // Add lotes inside polo (on top)
      if (lotesPolo?.features?.length > 0) {
        addGeoJsonLayer(map, 'lotes-polo', lotesPolo, {
          type: 'both',
          color: COLORS.lotesPolo,
          opacity: 0.5,
          lineWidth: 1,
          onClick: (e) => {
            const id = e.features[0]?.properties?.id
            if (id) window.location.href = `/lotes/${id}`
          }
        })
      }

    } catch (error) {
      console.error('Error loading quadra map data:', error)
    }
  }, [quadraId])

  return (
    <MapLibreMap
      onMapReady={handleMapReady}
      className={className}
      zoom={16}
    />
  )
}
